import { render } from "./App.vue?vue&type=template&id=04c18cd8"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=04c18cd8&lang=less"

import exportComponent from "C:\\Users\\20303\\Desktop\\yesant\\code\\novapay\\syt\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__